<template>
  <SAIDialogWrapper ref="dialog" @hide="$emit('cancel')" :value="show">
    <div class="q-px-lg">
      <p class="text-h4 text-weight-medium text-grey-10">
        Please select a reason for denying this request
      </p>
      <HRApprovalReasonSelect
        class="q-mb-md q-mt-lg"
        placeholder="Select Reason"
        :value="reason"
        :disable="saving || disable"
        @input="$emit('update:reason', $event)"
      />
      <SAIInput
        class="q-mb-lg"
        :value="notes"
        autogrow
        type="textarea"
        :disable="saving || disable"
        placeholder="Add Notes (optional)"
        @input="$emit('update:notes', $event)"
      />
      <div class="row justify-end">
        <SAIBtn
          no-caps
          size="16px"
          padding="10px lg"
          label="Confirm"
          autogrow
          :loading="saving"
          :disable="saving || disable || !reason"
          @click="$emit('confirm')"
        />
      </div>
    </div>
  </SAIDialogWrapper>
</template>

<script>
import { SAIDialogWrapper, SAIInput, SAIBtn } from 'ecx.saigon.ui.common';

export default {
  name: 'RejectApprovalDialog',
  props: {
    show: Boolean,
    reason: String,
    notes: String,
    saving: Boolean,
    disable: Boolean
  },
  watch: {
    show: {
      handler: function (value) {
        if (this.$refs.dialog) {
          value ? this.$refs.dialog.show() : this.$refs.dialog.hide();
        }
      },
      immediate: true
    }
  },
  components: {
    SAIDialogWrapper,
    SAIInput,
    SAIBtn,
    HRApprovalReasonSelect: () => import('../../atom/hr-approval-reason-select')
  }
};
</script>
